import { useState } from 'react';
import { CartEdge, CartItem, CartLineItemAdd } from '../../models/Cart';
import { CartLineInput, CartLinesAddResp } from '../../models/ShopifyCartShema';
import storageService, { Locals } from '../../utils/storageService';
import { getShopifyID } from '../../utils/utils';
import useShopifyCart from '../shopify/useShopifyCart';
import useCartUpdate from './useCartUpdate';

const useCart = () => {
    const shopifyCart = useShopifyCart();
    const cartUpdate = useCartUpdate();

    const [resettingCart, setResettingCart] = useState<boolean>(false);

    const createCart = () => {
        return shopifyCart
            .createNewShopifyCart({
                buyerIdentity: {
                    customerAccessToken: storageService.getItem(
                        Locals.SHOPIFY_ACCESS_TOKEN
                    ),
                },
                attributes: [
                    {
                        key: 'payment_method',
                        value: 'UTANVET',
                    },
                ],
            })
            .then((cartResp) => {
                storageService.setItem(
                    Locals.CART_TOKEN,
                    cartResp.cartCreate.cart.id
                );
                return cartResp;
            });
    };

    const convertCartLineItems = (product: CartItem): CartLineItemAdd => {
        return {
            merchandiseId:
                'gid://shopify/ProductVariant/' + product.shopify_variant_id,
            quantity: product.quantity == 0 ? 1 : product.quantity,
        };
    };

    const addProductsToCart = (
        productList: CartLineInput[]
    ): Promise<CartLinesAddResp> => {
        return shopifyCart.addNewProductToShopifyCart(productList);
    };

    const resetCart = (cartItems: CartEdge[]): void => {
        setResettingCart(true);

        const ids = cartItems.map((elem) => {
            return elem.node.id;
        });

        shopifyCart
            .removeCartItem(ids)
            .then(() => cartUpdate.updateCart())
            .then(() => setResettingCart(false));
    };

    const convertProductsIdsFromCart = (products: CartEdge[]): number[] =>
        products.map((elem) => +getShopifyID(elem.node.merchandise.product.id));

    return {
        createCart,
        addProductsToCart,
        convertCartLineItems,
        resetCart,
        convertProductsIdsFromCart,
        resettingCart,
    };
};

export default useCart;
